import { FilterField } from 'src/app/components/dialogs/select-filter-new/models/filter-field';
import { FieldDisplayType } from './field-display-type';

export class FieldValue {
    field: FilterField;
    value: any[];

    constructor(field: FilterField) {
        this.field = field;
        this.value = [];

        switch (this.field.displayType) {
            case FieldDisplayType.StaticDropdown:
                this.value.push(this.field.choices[0].value);
                break;
            case FieldDisplayType.Boolean:
            case FieldDisplayType.CustomCodingCheckbox:
            case FieldDisplayType.CustomCodingSharedCheckbox:
                this.value.push(true);
                break;
        }
    }
}
